import { render, staticRenderFns } from "./CustomerEmail.vue?vue&type=template&id=225ecc60"
import script from "./CustomerEmail.vue?vue&type=script&lang=js"
export * from "./CustomerEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports